// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"248":"3c9c99fbe6e7a28e","674":"deccf5e52ce3b9e7","8026":"deccf5e52ce3b9e7"}[chunkId] + ".css";
};